import React from 'react';

const CircleArrowRight = (props: object) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="13" cy="13" r="12.5" stroke="currentcolor" />
      <path
        d="M10.9414 18.2797L15.2881 13.9331C15.8014 13.4197 15.8014 12.5797 15.2881 12.0664L10.9414 7.71973"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CircleArrowRight;
